import Glide from '@glidejs/glide';

const initPostFooter = () => {
    let blocks = document.querySelectorAll('.js-footer-post-slider');
    if (!blocks) return;
    if (blocks.length < 1) return;

    let init = (block) => {
        let gliderRoot = block.querySelector('.glide');
        if (!gliderRoot) return;

        //const items = block.querySelectorAll('.glide__slide').length;

        let options = {
            type: 'carousel',
            perView: 5,
            bound: 0,
            autoplay: 0,
            focusAt: 1,
            animationDuration: 900,
            pauseOnHover: true,
            swipeThreshold: 40, //default 80, which is a bit too lazy
            dragThreshold: 60, //default 120, which is a bit too lazy
            touchAngle: 30,
            peek: { before: 0, after: 0 },
            gap: 35,
            breakpoints: {
                1439: {
                    gap: 15,
                    perView: 3,
                    focusAt: 0,
                    peek: { before: 30, after: 30 },
                },
                1023: {
                    gap: 15,
                    perView: 2,
                    focusAt: 0,
                    peek: { before: 30, after: 30 },
                },
                600: {
                    gap: 15,
                    perView: 1,
                    focusAt: 0,
                    peek: { before: 30, after: 30 },
                },
            },
        };

        const glide = new Glide(gliderRoot, options);
        /*
        const resize = () => {
            if (items <= glide.settings.perView - 2) {
                glide.pause();
                glide.disable();
                block.classList.add('is-disabled');
                return;
            }

            glide.play();
            glide.enable();
            block.classList.remove('is-disabled');
        };

        glide.on('resize', function () {
            resize();
        });
*/
        glide.on('mount.after', function () {
            gliderRoot.classList.add('mounted');
        });

        let left = block.querySelector('.js-left');
        let right = block.querySelector('.js-right');
        if (left) {
            left.addEventListener('click', () => {
                glide.go('<');
            });
        }
        if (right) {
            right.addEventListener('click', () => {
                glide.go('>');
            });
        }

        glide.mount();
        //resize();
    };

    blocks.forEach((block) => {
        init(block);
    });
};

export { initPostFooter };
